const StatusFinancement = ({ status }: { status: number }) => {
  const style =
    status == 1
      ? "bg-[#CFD8DC] text-[#323232]"
      : status == 2
      ? "bg-[#FF9500] text-white"
      : "bg-primary text-primary-foreground";
  return (
    <div className={`rounded-full px-3 py-1 no-underline ${style}`}>
      {status == 1
        ? "Pas encore financé"
        : status == 2
        ? "Partiellement financé"
        : "Entierement financé"}
    </div>
  );
};

export default StatusFinancement;
